import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable, map } from 'rxjs';
import {
  GET_EXPORTABLE_SUBMISSIONS,
  TRIGGER_ENERGY_CREDIT_SUBMISSION_EXPORT,
  TRIGGER_ENERGY_EFFICIENCY_BACKFILL,
  TRIGGER_HEAT_PUMP_INVOICE_SYNC,
} from '../queries/support.queries';
import {
  DELETE_CACHED_INSPECTION,
  GET_INSPECTION_PROGRESS,
  GET_ZONES_BY_FACILITY,
  SAVE_INSPECTION_PROGRESS,
} from 'src/app/modules/qbuilt/queries/qbuilt.queries';
import { MutationResult, UpdateResult } from 'src/app/shared/graph-queries/types';

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  constructor(private apollo: Apollo) {}

  getNumberOfExportableSubmissions(): Observable<number> {
    return this.apollo
      .query<any>({
        query: GET_EXPORTABLE_SUBMISSIONS,
      })
      .pipe(
        map((x) => {
          return x.data.GetExportableSubmissions.Count;
        }),
      );
  }

  triggerEnergyCreditSubmissionExport(): Observable<MutationResult> {
    return this.apollo.mutate({
      mutation: TRIGGER_ENERGY_CREDIT_SUBMISSION_EXPORT,
    });
  }

  triggerHeatPumpInvoiceSync(): Observable<MutationResult> {
    return this.apollo.mutate({
      mutation: TRIGGER_HEAT_PUMP_INVOICE_SYNC,
    });
  }

  triggerEnergyEfficiencyBackfill(): Observable<MutationResult> {
    return this.apollo.mutate({
      mutation: TRIGGER_ENERGY_EFFICIENCY_BACKFILL,
    });
  }

  // ── QBuilt Inspection Support ──────────────────────────────────────────────

  getZonesByFacility(plantNumber: string): Observable<{ Id: number; Name: string; HBGFacilityNumber: string }[]> {
    return this.apollo
      .query<any>({
        query: GET_ZONES_BY_FACILITY,
        variables: { userFacility: plantNumber },
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      })
      .pipe(map((res) => res.data?.GetZoneConfigurationsByFacility ?? []));
  }

  getInspectionProgress(pk: string): Observable<{ Pk: string; InspectionData: string } | null> {
    return this.apollo
      .query<any>({
        query: GET_INSPECTION_PROGRESS,
        variables: { filter: pk },
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      })
      .pipe(map((res) => res.data?.GetInspectionProgress ?? null));
  }

  saveInspectionProgress(pk: string, inspectionData: any[]): Observable<MutationResult<UpdateResult>> {
    return this.apollo.mutate({
      mutation: SAVE_INSPECTION_PROGRESS,
      variables: { payload: JSON.stringify({ Pk: pk, InspectionData: inspectionData }) },
      fetchPolicy: 'no-cache',
    });
  }

  deleteInspection(pk: string): Observable<MutationResult<UpdateResult>> {
    return this.apollo.mutate({
      mutation: DELETE_CACHED_INSPECTION,
      variables: { payload: pk },
      fetchPolicy: 'no-cache',
    });
  }
}
